import React from 'react';
import '../Login/termsModal.css';

const TermsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>✖</button>
        <h2 className="modal-title">Términos y Condiciones</h2>
        <div className="modal-body">
          <p>
            Términos y Condiciones TÉRMINOS Y CONDICIONES DE LOS SERVICIOS El simple acceso al SITIO WEB y la aceptación en la APP...
          </p>
          {/* Puedes agregar más contenido aquí si lo necesitas */}
        </div>
      </div>
    </div>
  );
};

export default TermsModal;